

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RackTrayRefDto, CabinetShelfRefDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-rackettrayref',
  templateUrl: './rackettrayref.component.html',
  styleUrls: ['./rackettrayref.component.scss']
})
export class RackettrayrefComponent implements OnInit {


  @Input() cabinetshelfrefs: CabinetShelfRefDto[];
  @Input() racktrayrefs: RackTrayRefDto[];
  racktrayrefForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<RackTrayRefDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedCompany: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedRackTrayRef: any;
  filteredRackTrayRef: Array<any> = [];
  status: boolean;
  selectedRackTrayRefId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.racktrayrefForm = this.fb.group({ RackTrayRefs: this.fb.array([]) });
    // this.setRackTrayRef();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display companies
  setRackTrayRef() {
    const control = this.racktrayrefForm.controls.RackTrayRefs as FormArray;
    this.filteredRackTrayRef.forEach((e) => {
      control.push(
        this.fb.group({
          RackTrayRefNo: e.RackTrayRefNo,
          CabinetShelfRefId: e.CabinetShelfRefId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.racktrayrefForm.controls.RackTrayRefs as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter racktrayref
  selectCabinetShelfRef(event: string) {
    console.log('racktrayrefs', this.racktrayrefs);
    this.filteredRackTrayRef = this.racktrayrefs.filter((s) => s.CabinetShelfRefId === event);
    console.log('country id', event, this.filteredRackTrayRef);

    this.selectedRackTrayRefId = event;
    const control = this.racktrayrefForm.controls.RackTrayRefs as FormArray;

    if (this.filteredRackTrayRef.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setRackTrayRef();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Company
  addRackTrayRef() {
    const control = this.racktrayrefForm.controls.RackTrayRefs as FormArray;
    control.insert(
      0,
      this.fb.group({
        RackTrayRefNo: ['', Validators.required],
        CabinetShelfRefId: this.selectedRackTrayRefId
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteRackTrayRef(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.racktrayrefForm.controls.RackTrayRefs as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.racktrayrefs.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.racktrayrefs[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'racktrayref';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('racktrayref');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }


}
